/**
 * kpiShift模块接口列表
 */
import $http from '../utils/http'// 导入http中创建的axios实例

const kpiShift = {
  // 添加或编辑
  insertOrUpdate(params) {
    return $http.post(`${global.API_URL}/sme/kpiShift/insertOrUpdate`, params);
  },
  // 分页查询
  pageOperationDuty(params) {
    return $http.post(`${global.API_URL}/sme/kpiShift/page`, params);
  },
  // 值班重复检查
  checkRepetitionShift(params) {
    return $http.post(`${global.API_URL}/sme/kpiShift/checkRepetitionShift`, params);
  },
  // 删除
  deleteOperationDuty(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/kpiShift/delete`, param);
  },
  // 查询排班优先级
  selectSchedulingPriorityList(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/kpiShift/selectSchedulingPriorityList`,param);
  },
  //导出
  exportOperationShift(params) {
    return $http.post(`${global.API_URL}/sme/kpiShift/exportOperationShift`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  }
}

export default kpiShift



// WEBPACK FOOTER //
// ./src/api/kpiShift.js